import type { PublicGovernmentResponse } from '@govinity/validation/public';

import { LegislativeItemsApi } from './legislative-items';
import { LegislativeStatusesApi } from './legislative-statuses';
import { LegislativeTypesApi } from './legislative-types';
import { LocationsApi } from './locations';
import { MeetingsApi } from './meetings';
import { MeetingBodiesApi } from './meeting-bodies';
import { MeetingBodyCategoriesApi } from './meeting-bodies-categories';
import { PublicCommentsApi } from './public-comments';
import { PublicDocumentsApi } from './public-documents';
import { PublicSpeakersApi } from './public-speakers';
import { ReadOnlyApi } from '../base';

export const PATH = '/governments';

class GovernmentsApi extends ReadOnlyApi<PublicGovernmentResponse, object> {
  getPath() {
    return PATH;
  }

  async get(governmentCode: string) {
    const { data } = await this.request<PublicGovernmentResponse>({
      method: 'GET',
      url: `${this.getPath()}/${governmentCode}`,
    });

    return data;
  }

  meetings(governmentCode: string) {
    return new MeetingsApi(governmentCode, this.getPath());
  }

  locations(governmentCode: string) {
    return new LocationsApi(governmentCode, this.getPath());
  }

  meetingBodies(governmentCode: string) {
    return new MeetingBodiesApi(governmentCode, this.getPath());
  }

  meetingBodyCategories(governmentCode: string) {
    return new MeetingBodyCategoriesApi(governmentCode, this.getPath());
  }

  legislativeItems(governmentCode: string) {
    return new LegislativeItemsApi(governmentCode, this.getPath());
  }

  legislativeTypes(governmentCode: string) {
    return new LegislativeTypesApi(governmentCode, this.getPath());
  }

  legislativeStatuses(governmentCode: string) {
    return new LegislativeStatusesApi(governmentCode, this.getPath());
  }

  publicDocuments(governmentCode: string) {
    return new PublicDocumentsApi(governmentCode, this.getPath());
  }

  publicSpeakers(governmentCode: string) {
    return new PublicSpeakersApi(governmentCode, this.getPath());
  }

  publicComments(governmentCode: string, meetingId: number) {
    return new PublicCommentsApi(governmentCode, meetingId, this.getPath());
  }
}

export default new GovernmentsApi();
